import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ICountry, IMechanicSchoolAdminBody, IMechanicSchoolLabel, IRegisterMechanicsLocationDetails } from '../../../../core/models';
import { MasterDataService } from '../../../../core/services/master-data.service';
import { SchoolAndTrainingService } from '../../../../core/services/school-and-training.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { map, tap } from 'rxjs/operators';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { environment } from '../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../../../../core/services/user.service';
import { FreightClaimService } from '../../../../core/services/freight-claim.service';
import { SelectEvent } from '@progress/kendo-angular-charts';

@Component({
  selector: 'app-mechanics-school',
  templateUrl: './mechanics-school.component.html',
  styleUrls: ['./mechanics-school.component.scss']
})
export class MechanicsSchoolComponent implements OnInit {
  //#region member/variable declaration
  mechanicsSchoolTxt: IMechanicSchoolLabel;
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;

  public position = 'top';
  registrationForm: FormGroup;
  mechanicsSchoolData: any;
  countries: any;
  states: any;
  saveInProcess: boolean;
  pdfUrl: string = "";
  schoolDescriptionPdfUrl: any = null;
  registrationDescriptionPdfUrl: any = null;
  //#endregion
  constructor(private formBuilder: FormBuilder, private trainingService: SchoolAndTrainingService, private appNotifyService: AppNotifyService,
    private masterService: MasterDataService, private languageTranslationService: LanguageTranslationService, private sanitizer: DomSanitizer,
    private userService: UserService, private freightClaimService: FreightClaimService) { }

  ngOnInit() {
    this.loadLanguageTranslationData();
    this.initilizeForm();
    this.loaadDetails();
    this.masterService.GetCountries().pipe(tap((countries: ICountry[]) => {
      this.masterService.countries = countries as ICountry[];
    })).subscribe((countries: ICountry[]) => {
      this.countries = countries as ICountry[];
    })
    //this.pdfUrl = environment.imageUrl + "/ResourceCenter/content/KawneerTrainingWaiver.pdf";
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "mechnicsSchoolInformationLbl" },
      { controlName: "mechnicsSchoolLbl" },
      { controlName: "locationInformationLbl" },
      { controlName: "registrationLbl" },
      { controlName: "onlineRegistrationLbl" },
      { controlName: "firstNameLbl" },
      { controlName: "lastNameLbl" },
      { controlName: "jobTitleLbl" },
      { controlName: "companyNameLbl" },
      { controlName: "addressLbl" },
      { controlName: "cityLbl" },
      { controlName: "commentLbl" },
      { controlName: "emailLbl" },
      { controlName: "phoneNumber" },
      { controlName: "faxNumberLbl" },
      { controlName: "countryLbl" },
      { controlName: "stateLbl" },
      { controlName: "zipCodeLbl" },
      { controlName: "selectSeminarLbl" },
      { controlName: "continueLbl" },
      { controlName: "submitLbl" },
      { controlName: "cancelLbl" },
      { controlName: "invalidEmail" },
      { controlName: "infoLbl" },
      { controlName: "priceLbl" },
      { controlName: "invalidPhoneLbl" },
      { controlName: "pdfLinkLbl" },
      { controlName: "liabilityWaiverLbl" },
      { controlName: "seatsLbl" },
      { controlName: "remainingSeatsLbl" },
      { controlName: "invalidLocation" },

    ];
    const componentName = "mechanicsschool";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.mechanicsSchoolTxt = response[response.length - 1];
    }
  }

  //#endregion
  registerMechanicsLocationList: any = [];
  seminarCheck(val) {
    const rowIndex = this.mechanicsSchoolData.mechanicsSchoolLocationDetails.findIndex(r => r.locationId === val.locationId);
    if (this.registerMechanicsLocationList.length > 0) {
      const isExist = this.registerMechanicsLocationList.find(p => (p.locationId === val.locationId && p.isChecked === true)); //checking if switch is unchecked and if exist 
      if (isExist) {
        const index = this.registerMechanicsLocationList.findIndex(p => (p.locationId === val.locationId && p.isChecked === true));
        this.registerMechanicsLocationList.splice(index, 1);
        if (this.registerMechanicsLocationList.length == 0) {
          this.mechanicsSchool.isInvalidLocation = true;
        } else {
          this.mechanicsSchool.isInvalidLocation = false;
        }
        return;
      }
    }
    const locationList = { id: 0, registrationId: "", locationId: this.mechanicsSchoolData.mechanicsSchoolLocationDetails[rowIndex].locationId, isChecked: true };
    this.registerMechanicsLocationList.push(locationList);
    if (this.registerMechanicsLocationList.length == 0) {
      this.mechanicsSchool.isInvalidLocation = true;
    } else {
      this.mechanicsSchool.isInvalidLocation = false;
    }
  }
  countySelectionChange(event) {
    if (event) {
      this.states = event.states;
    }
  }
  //#region intiize form controls and load details
  loaadDetails() {
    const body = {
      languageCode: localStorage.getItem("language")
    }
    this.trainingService.getMechanicsSchoolDetails(body).subscribe(response => {
      if (response.length > 0) {
        this.mechanicsSchoolData = response[0];
        if (this.mechanicsSchoolData.schoolDescriptionPdfUrlPath) {
          const url = environment.imageUrl + this.mechanicsSchoolData.schoolDescriptionPdfUrlPath;
          this.displayDocument(url);
          this.schoolDescriptionPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
        if (this.mechanicsSchoolData.registrationDescriptionPdfUrlPath) {
          const url = environment.imageUrl + this.mechanicsSchoolData.registrationDescriptionPdfUrlPath;
          this.pdfUrl = url;
          this.registrationDescriptionPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
      }
    });
    this.masterService.GetCountries().subscribe(response => {
      this.countries = response;
    })
  }
  initilizeForm() {
    this.registrationForm = this.formBuilder.group({
      firstName: new FormControl(),
      lastName: new FormControl(),
      jobTitle: new FormControl(),
      companyName: new FormControl(),
      address: new FormControl(),
      city: new FormControl(),
      comments: new FormControl(),
      email: new FormControl(),
      phoneNumber: new FormControl(),
      faxNumber: new FormControl(),
      country: new FormControl(),
      state: new FormControl(),
      zipCode: new FormControl(),
    })
  }
  //#endregion
  //#region label/variable declaration
  public mechanicsSchool = {
    mechnicsSchoolInformationLbl: "MECHANICS SCHOOL INFORMATION",
    mechnicsSchoolLbl: "Mechanics School",
    locationInformationLbl: "Location Information",
    registrationLbl: "Registration",
    liabilityWaiverLbl: "Liability Waiver",
    pdfLinkLbl: "Click here to download PDF",
    onlineRegistrationLbl: 'ONLINE REGISTRATION',
    firstNameLbl: 'First Name',
    lastNameLbl: 'Last Name',
    jobTitleLbl: 'Job Title',
    companyNameLbl: 'Company Name',
    addressLbl: 'Address',
    cityLbl: 'City',
    commentLbl: 'Comments',
    emailLbl: 'Email',
    phoneNumber: 'Phone Number',
    faxNumberLbl: 'Fax Number',
    countryLbl: 'Country',
    stateLbl: 'State',
    zipCodeLbl: 'Zip Code',
    selectSeminarLbl: 'Please select the seminar(s) you would like to attend',
    continueLbl: 'Continue',
    submitLbl: 'Submit',
    cancelLbl: 'Cancel',
    priceLbl: 'Price',
    infoLbl: '*You must register on-line to receive special KawneerDirect price.',
    currentYear: new Date().getFullYear(),
    isEmptyFirstName: false,
    isEmptyJobTitle: false,
    isEmptyCompanyName: false,
    isEmptyPhoneNumber: false,
    isInvalidPhoneNumber: false,
    isEmptyEmail: false,
    isInvalidEmail: false,
    invalidEmail: "Email address is invalid",
    invalidPhoneLbl: "Phone number length should be minimum 10",
    isSubmitted: false,
    seatsLbl: 'Seats',
    isInvalidLocation: false,
    invalidLocation:"Please select at least one location",
    remainingSeatsLbl: 'Available Seats',
  }
  //#endregion
  //#region validation
  public checkEmail(email) {
    const regExp = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    return regExp.test(String(email).toLowerCase());
  }
  emailLeave() {
    const controls = this.registrationForm.controls;
    if (controls.email.value) {
      const res = this.checkEmail(controls.email.value);
      if (!res) {
        this.mechanicsSchool.isInvalidEmail = true;
        this.mechanicsSchool.isEmptyEmail = true;
      } else {
        this.mechanicsSchool.isInvalidEmail = false;
        this.mechanicsSchool.isEmptyEmail = false;
      }
    }
    else {
      this.mechanicsSchool.isInvalidEmail = false;
      this.mechanicsSchool.isEmptyEmail = true;
    }
  }
  public validateMechanicsSchoolForm(): boolean {
    let isValid = true;
    const controls = this.registrationForm.controls;
    if (this.mechanicsSchool.isSubmitted) {
      if (controls.firstName.value) {
        this.mechanicsSchool.isEmptyFirstName = false;
      } else {
        this.mechanicsSchool.isEmptyFirstName = true;
        isValid = false;
      }
      if (controls.companyName.value) {
        this.mechanicsSchool.isEmptyCompanyName = false;
      } else {
        this.mechanicsSchool.isEmptyCompanyName = true;
        isValid = false;
      }
      if (controls.jobTitle.value) {
        this.mechanicsSchool.isEmptyJobTitle = false;
      } else {
        this.mechanicsSchool.isEmptyJobTitle = true;
        isValid = false;
      }
      if (controls.email.value) {
        const res = this.checkEmail(controls.email.value);
        if (!res) {
          this.mechanicsSchool.isInvalidEmail = true;
          this.mechanicsSchool.isInvalidEmail = true;
          isValid = false;
        } else {
          this.mechanicsSchool.isInvalidEmail = false;
          this.mechanicsSchool.isEmptyEmail = false;
        }
      } else {
        this.mechanicsSchool.isEmptyEmail = true;
        isValid = false;
      }
      if (controls.phoneNumber.value) {
        this.mechanicsSchool.isEmptyPhoneNumber = false;
        if ((controls.phoneNumber.value as string).toString().length !== 10) {
          this.mechanicsSchool.isEmptyPhoneNumber = true;
          this.mechanicsSchool.isInvalidPhoneNumber = true;
          isValid = false;
        } else {
          this.mechanicsSchool.isInvalidPhoneNumber = false;
          this.mechanicsSchool.isInvalidPhoneNumber = false;
        }
      } else {
        this.mechanicsSchool.isEmptyPhoneNumber = true;
        this.mechanicsSchool.isInvalidPhoneNumber = false;
        isValid = false;
      }
      if (this.registerMechanicsLocationList.length == 0) {
        this.mechanicsSchool.isInvalidLocation = true;
        isValid = false;
      } else {
        this.mechanicsSchool.isInvalidLocation = false;
      }
    }
    return isValid;
  }
  //#endregion
  resetForm() {
    this.registrationForm.reset();
    this.mechanicsSchool.isSubmitted = false;
    this.mechanicsSchool.isEmptyFirstName = false;
    this.mechanicsSchool.isEmptyCompanyName = false;
    this.mechanicsSchool.isEmptyJobTitle = false;
    this.mechanicsSchool.isEmptyFirstName = false;
    this.mechanicsSchool.isEmptyPhoneNumber = false;
    this.mechanicsSchool.isInvalidPhoneNumber = false;
    this.mechanicsSchool.isEmptyEmail = false;
    this.mechanicsSchool.isInvalidEmail = false;
  }
  //#region submit button operation
  submit() {
    this.mechanicsSchool.isSubmitted = true;
    if (!this.validateMechanicsSchoolForm()) {
      return;
    }
    const controls = this.registrationForm.controls;
    const body = {
      id: 0,
      registrationId: "",
      firstName: controls.firstName.value,
      lastName: controls.lastName.value,
      jobTitle: controls.jobTitle.value,
      companyName: controls.companyName.value,
      address: controls.address.value,
      city: controls.city.value,
      comments: controls.comments.value,
      email: controls.email.value,
      phoneNumber: controls.phoneNumber.value ? controls.phoneNumber.value.toString() : "",
      faxNumber: controls.faxNumber.value,
      country: controls.country.value,
      state: controls.state.value.stateDescription,
      zipCode: controls.zipCode.value,
      mechanicsSchoolLocationRegistration: this.registerMechanicsLocationList as IRegisterMechanicsLocationDetails[],
      userName: this.userService.readUserObject.userName,
      customerName: this.userService.readUserObject.customerName,
      customerNumber: this.userService.readUserObject.customerNumber
    }
    this.trainingService.registerMechanicsSchool(body).subscribe(response => {
      this.resetForm();
      this.appNotifyService.notify(NotifyType.SUCCESS, 'Saved successfully!');
    })
  }
  //#endregion
  //#region panel change
  continueToNextPanel() {
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    this.panel.childrenItems[1].expanded = true;
    this.panel.childrenItems[1].selected = true;
  }

  public activatePanel(index: number) {
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    if (index !== -1) {
      this.panel.childrenItems[index].expanded = true;
      this.panel.childrenItems[index].selected = true;
    }
  }
  //#endregion
  onPanelBarSelect(e) {
    if (e.item.id =='mechSchInfo') {
      this.loaadDetails()
    }
  }
  onTabSelected(e) {
    if (e.index == 0) {
      this.loaadDetails();
    }
  }
  secureUrl: any;
  public openDocument(pathName: any) {
    const body = {
      Url: pathName,
    }
    this.freightClaimService.getDocument(body).subscribe((response) => {
      if (response) {
        console.log(response);
        const blob: Blob = (response && (response as any).body)
          ? (response as any).body
          : (response as Blob);
        if (blob) {
          console.log(blob.type);
          const fileName = 'download';
          //const fileName = ((child && child.partNo) ? partNo : 'download');
          const url = window.URL.createObjectURL(blob);
          this.secureUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url)
          window.open(url, '_blank');
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 5000);

          //const downloadLink = document.createElement('a');
          //downloadLink.href = url;
          //downloadLink.download = fileName;
          //downloadLink.click();
          //window.URL.revokeObjectURL(url);
        }
      }
    });
  }
  public displayDocument(pathName: any) {
    const body = {
      Url: pathName,
    }
    this.freightClaimService.getDocument(body).subscribe((response) => {
      if (response) {
        console.log(response);
        const blob: Blob = (response && (response as any).body)
          ? (response as any).body
          : (response as Blob);
        if (blob) {
          console.log(blob.type);
          const fileName = 'download';
          //const fileName = ((child && child.partNo) ? partNo : 'download');
          const url = window.URL.createObjectURL(blob);
          this.secureUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url)

          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 5000);

          //const downloadLink = document.createElement('a');
          //downloadLink.href = url;
          //downloadLink.download = fileName;
          //downloadLink.click();
          //window.URL.revokeObjectURL(url);
        }
      }
    });
  }
}
